import * as React from 'react';
import ExtractionBatchReExtract from './actions/ExtractionBatchReExtract';
import ExtractionBatchReTransform from './actions/ExtractionBatchReTransform';
import { AppContext } from '../../App';
import { IExtractionBatch } from '../../types/my-types';
import { getIdFromUrl } from '../../utils/getIdFromUrl';
import { Link, useNavigate } from 'react-router';

import { Divider } from '@mui/material';
import ListItemIcon from '@mui/material/ListItemIcon';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import PageviewIcon from '@mui/icons-material/Pageview';
import ReviewIcon from '@mui/icons-material/RateReview';
import ExtractionBatchDelete from './actions/ExtractionBatchDelete';
import ExtractionBatchSend from './actions/ExtractionBatchSend';
import ExtractionBatchDownloadModal from './actions/ExtractionBatchDownloadModal';
import ExtractionBatchClean from './actions/ExtractionBatchClean';
import ExtractionBatchExperimental from './actions/ExtractionBatchExperimental';
import MenuItemHiddenTextLabel from '../common/MenuItemHiddenTextLabel';

interface ExtractionBatchActionsProps {
  eb: IExtractionBatch;
  setLoadingSendExtractionBatch: Function;
}

const ExtractionBatchActions: React.FC<ExtractionBatchActionsProps> = ({
  eb,
  setLoadingSendExtractionBatch,
}) => {
  const { dataPoolId } = React.useContext(AppContext);

  // TODO: quickview doesn't show extractions url, ask quickview to expose a list of extraction ids instead
  const firstExtractionId = getIdFromUrl(eb.first_extraction);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // TODO: handle core version
  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        data-cy={`btn-extraction-batch-actions-${eb.label}`}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          'aria-labelledby': 'long-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem
          key={'Review'}
          data-cy={`btn-extraction-review-${eb.label}`}
          component={Link}
          to={`/data-pools/${dataPoolId}/extraction-batch/${eb.id}/review/${firstExtractionId}`}
          onClick={(event) => {
            handleClose();
          }}
          onAuxClick={handleClose}
          sx={{ fontSize: '0.875rem', padding: '4px 8px' }}
        >
          <ListItemIcon>
            <ReviewIcon fontSize="small" />
          </ListItemIcon>
          <MenuItemHiddenTextLabel>Review</MenuItemHiddenTextLabel>
        </MenuItem>

        <MenuItem
          key={'Transformed'}
          data-cy={`btn-extraction-transformed-${eb.label}`}
          component={Link}
          to={`/data-pools/${dataPoolId}/extraction-batch/${eb.id}/transformed`}
          onClick={(event) => {
            handleClose();
          }}
          onAuxClick={handleClose}
          sx={{ fontSize: '0.875rem', padding: '4px 8px' }}
        >
          <ListItemIcon>
            <PageviewIcon fontSize="small" />
          </ListItemIcon>
          <MenuItemHiddenTextLabel>Transformed</MenuItemHiddenTextLabel>
        </MenuItem>

        <Divider />

        <ExtractionBatchClean extractionBatch={eb} handleClose={handleClose} type="menu" />
        <ExtractionBatchReTransform extractionBatch={eb} handleClose={handleClose} type="menu" />
        <ExtractionBatchReExtract
          extractionBatch={eb}
          coreVersion="4.0.0"
          handleClose={handleClose}
          type="menu"
        />
        <Divider />
        <ExtractionBatchExperimental extractionBatch={eb} handleClose={handleClose} type="menu" />

        <Divider />

        <ExtractionBatchDownloadModal
          extractionBatch={eb}
          ebFinished={eb.finished}
          handleClose={handleClose}
          type="menu"
        />

        <Divider />

        <ExtractionBatchSend
          extractionId={eb.id}
          ebLabel={eb.label}
          ebFinished={eb.finished}
          isExpired={eb.verified?.expired}
          isVerified={Boolean(eb.verified?.is_verified)}
          verifiedUpdatedAt={eb.verified?.updated_at}
          setLoadingState={setLoadingSendExtractionBatch}
          handleClose={handleClose}
          type="menu"
        />

        <Divider />

        <ExtractionBatchDelete extractionBatchId={eb.id} handleClose={handleClose} type="menu" />
      </Menu>
    </div>
  );
};

export default ExtractionBatchActions;
